import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spin, Table, Typography, Input, Radio, Switch, message } from 'antd';
import { viewDomainReq } from '../../Domain/Domain.service';
import { getDomainById, rejectDomainChangeRequest, saveDomainChanges } from './DomainAdmin.service';
import { SIZE, BitOptions, ERROR_MSG } from '../../Helper/Constant';
const { Text, Link } = Typography;

let USERNAME = null;

const DomainAdmin = ({ user }) => {
    USERNAME = user;
    const tableColumn = [
        {
            title: 'Request Id',
            dataIndex: 'id',
            key: 'id',
            width: '6%',
        },
        {
            title: 'Request Type',
            dataIndex: 'req_type',
            key: 'req_type',
            width: '7%',
        },
        { title: 'Domain Id', dataIndex: 'domain_id', key: 'domain_id', width: '5%' },
        { title: 'Domain Name', dataIndex: 'domain_name', key: 'domain_name', width: '25%' },
        { title: 'App Id', dataIndex: 'application_id', key: 'application_id', width: '5%' },
        {
            title: 'Comment',
            dataIndex: 'comments',
            key: 'comments',
            width: '25%',
            render: (value) => <Text className='ns-white-space-break'>{value}</Text>,
        },
        { title: 'Requested By', dataIndex: 'req_by', key: 'req_by', width: '8%' },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            render: (value, row) => (
                <Link
                    className='ns-margin-right'
                    onClick={() => {
                        setModalData(row);
                        setModalOpen(true);
                    }}
                >
                    Process
                </Link>
            ),
        },
    ];

    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState({});

    useEffect(() => {
        fetchTableData();
    }, []);

    const fetchTableData = async () => {
        setLoading(true);
        await viewDomainReq().then((res) => {
            if (res) {
                setTableData(res);
            }
        });
        setLoading(false);
    };

    const closeModal = (refresh) => {
        setModalOpen(false);
        if (refresh) {
            fetchTableData();
        }
    };

    return (
        <>
            <Table
                columns={tableColumn}
                dataSource={tableData}
                key={'domain_requets'}
                loading={loading}
                rowKey={'id'}
                size='small'
                bordered
                pagination={false}
            ></Table>
            <Modal
                title={'Handle Domain Requests'}
                open={modalOpen}
                onCancel={() => closeModal(false)}
                footer={null}
                width={'80%'}
                destroyOnClose
            >
                <HandleDomainRequest reqData={modalData} closeModal={closeModal} />
            </Modal>
        </>
    );
};

const HandleDomainRequest = ({ reqData, closeModal }) => {
    const valueShowOrder = {
        req_type: 'Req Type',
        domain_id: 'Domain Id',
        domain_name: 'Domain Name',
        application_id: 'Application Id',
        comments: 'Comments',
    };

    const oldDomainValueOrder = {
        domain_name: 'Domain Name',
        application_id: 'Application Id',
        b_skip_for_forwarder: 'Skip Forwarder',
        b_skip_for_explicit_proxy: 'Skip Explicit Proxy',
        b_skip_for_agent: 'Skip Agent',
        is_login_domain: 'Login Domain',
        additional_discovery_domain: 'Additional Discovery',
        skip_app_mapping: 'Skip App Mapping',
    };

    const [loading, setLoading] = useState(false);
    const [oldDomainData, setOldDomainData] = useState(null);

    useEffect(() => {
        console.log('reqData:', reqData);
        if (reqData?.req_type !== 'ADD') {
            fetchDomainData();
        }
    }, [reqData]);

    const fetchDomainData = async () => {
        setLoading(true);
        await getDomainById(reqData.domain_id).then((res) => {
            console.log('Domain: ', res);
            if (res) {
                setOldDomainData(res);
            }
        });
        setLoading(false);
    };
    return (
        <>
            {loading ? (
                <div className='container ns-flex_center'>
                    <Spin />
                </div>
            ) : (
                <div className='ns-flex ns-flex_column ns-flex_gap'>
                    <Card size='small' title='Requested Data'>
                        <div className='ns-flex'>
                            {Object.entries(valueShowOrder).map(([key, value]) => {
                                return (
                                    <div className='ns-margin-right-xx-large ns-flex ns-flex_gap' key={'req_' + key}>
                                        <Text type='secondary'>{value}:</Text>
                                        <Text className='ns-white-space-break'>{reqData[key] ?? '-'}</Text>
                                    </div>
                                );
                            })}
                        </div>
                    </Card>
                    {oldDomainData ? (
                        <Card size='small' title='Old Domain Entry'>
                            <div className='ns-flex'>
                                {Object.entries(oldDomainValueOrder).map(([key, value]) => {
                                    return (
                                        <div className='ns-margin-right-xx-large ns-flex ns-flex_gap' key={'old_' + key}>
                                            <Text type='secondary'>{value}:</Text>
                                            <Text className='ns-white-space-break'>{oldDomainData[key] ?? '-'}</Text>
                                        </div>
                                    );
                                })}
                            </div>
                        </Card>
                    ) : (
                        ''
                    )}
                    <Card size='small' title='Domain field form'>
                        <DomainChangesForm initValues={reqData} closeModal={closeModal} />
                    </Card>
                </div>
            )}
        </>
    );
};

const DomainChangesForm = ({ initValues, closeModal }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFormChange = (changedValues, allValues) => {
        console.log('On form change', changedValues, allValues);
        if (!allValues?.steering_enabled) {
            if (allValues.skip_app_mapping) {
                form.setFieldValue('additional_discovery_domain', -1);
            }
        }
    };

    const onFinishForm = async (values) => {
        setLoading(true);
        console.log('On Finish : ', values);
        values['domain_name'] = values?.domain_name.trim();
        const postData = {
            ...values,
            domain_id: initValues.domain_id,
            action: initValues.req_type,
            comments: initValues.comments + generateComments(values),
        };
        console.log('Post : ', postData);
        await saveDomainChanges(postData, initValues.id, USERNAME).then((res) => {
            if (res?.status === 1) {
                closeModal(true);
            } else {
                message.error(res?.msg ?? ERROR_MSG.GENERAL_ERROR);
            }
        });
        setLoading(false);
    };

    const generateComments = (values) => {
        let comments = '\n--ADMIN--\n';
        if (values?.admin_comments) {
            comments += `${values.admin_comments}\n`;
        }
        if (values.req_type === 'ADD') {
            comments += `Domain: ${values.domain_name}\n`;
            comments += `App ID: ${values.application_id}\n`;
        }
        if (initValues.steering_enabled != values.steering_enabled) {
            comments += `Steering Enabled: ${values.steering_enabled}\n`;
        }
        if (initValues.skip_app_mapping != values.skip_app_mapping) {
            comments += `Skip App Mapping: ${values.skip_app_mapping}\n`;
        }
        if (initValues.additional_discovery_domain != values.additional_discovery_domain) {
            comments += `Discovery: ${values.additional_discovery_domain}\n`;
        }
        comments += '--- End ADMIN ---\n';
        return comments;
    };

    const onRejectReq = async () => {
        console.log('Req Rejected');
        setLoading(true);
        await rejectDomainChangeRequest(initValues.id, USERNAME).then((res) => {
            if (res) {
                closeModal(true);
            }
        });
        setLoading(false);
    };
    return (
        <Form
            name='domain_change'
            form={form}
            onValuesChange={onFormChange}
            onFinish={onFinishForm}
            autoComplete={'off'}
            disabled={loading}
            size={SIZE.SMALL}
            initialValues={initValues}
        >
            <Row gutter={[16, 16]}>
                <Col span={16}>
                    <Form.Item label='Domain name' name='domain_name' rules={[{ required: true }]}>
                        <Input disabled={initValues.req_type !== 'ADD'} />
                    </Form.Item>
                    <Form.Item label='Application Id' name='application_id' rules={[{ required: true }]}>
                        <Input type={'number'} disabled={initValues.req_type !== 'ADD'} />
                    </Form.Item>
                    <div className='ns-flex ns-flex_space-between'>
                        <Form.Item name='steering_enabled' label='Steering Enabled' valuePropName='checked'>
                            <Switch />
                        </Form.Item>
                        <Form.Item name='skip_app_mapping' label='Skip App Mapping' valuePropName='checked'>
                            <Switch />
                        </Form.Item>
                        <Form.Item name='additional_discovery_domain' label='Additional Discovery Domain'>
                            <Radio.Group options={BitOptions} optionType='button' buttonStyle='solid' />
                        </Form.Item>
                    </div>
                </Col>
                <Col flex={'auto'}>
                    <Form.Item label='Comments' name='admin_comments'>
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Col>
            </Row>

            <div className='ns-flex ns-flex_gap'>
                <Button onClick={onRejectReq} danger>
                    Reject
                </Button>

                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default DomainAdmin;
